export default __webpack_public_path__ + "static/media/1.e4a5f2d9.png";